// #region Imports
import React, { useState, useEffect } from 'react';
import './ServicosTable.scss';
import iconEdit from '../../../assets/edit.svg';
import iconTrash from '../../../assets/trash.svg';
import { formatCurrency } from '../../../../shared/helpers';
// #endregion

export default function ServicosTable({
  loading = false,
  filters,
  categorias = [],
  data = [],
  total = 0,
  page = 1,
  pageSize = 10,
  onFiltersChange = () => {},
  onPageChange = () => {},
  onCreate = () => {},
  onEdit = () => {},
  onDelete = () => {},
}) {
  // #region Estado filtros locais
  const [local, setLocal] = useState(filters);
  useEffect(() => { setLocal(filters); }, [filters]);
  // #endregion

  // #region Handlers
  function update(patch) {
    const next = { ...local, ...patch };
    setLocal(next);
    onFiltersChange(next);
  }
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  function jumpToPage(p) { onPageChange(Math.min(Math.max(1, p), totalPages)); }
  // #endregion

  // #region Render helpers
  const renderBody = () => {
    if (loading) {
      return Array.from({ length: 6 }).map((_, i) => (
        <tr key={`sk-${i}`} className="skeleton-row" aria-hidden="true">
          <td colSpan="6">
            <div className="sk-line w40" />
            <div className="sk-line w25" />
          </td>
        </tr>
      ));
    }
    if (!data.length) {
      return (
        <>
          <tr>
            <td colSpan="6" className="empty-cell">Nenhum serviço encontrado.</td>
          </tr>
          {Array.from({ length: 5 }).map((_, i) => (
            <tr key={`empty-${i}`} className="row-filler" aria-hidden="true">
              <td colSpan="6" />
            </tr>
          ))}
        </>
      );
    }
    return (
      <>
        {data.map(s => (
          <tr key={s.id}>
            <td>
              <div className="cell-main">
                <span className="cell-title">{s.nome}</span>
                {s.descricao && <span className="cell-sub">{s.descricao}</span>}
              </div>
            </td>
            <td><span className="tag tag-cat">{s.categoria}</span></td>
            <td>{s.descricao}</td>
            <td>{formatCurrency(s.preco_padrao)}</td>
            <td>{(s.perc_comissao_padrao || 0).toFixed(1)}%</td>
            <td className="actions">
              <button
                type="button"
                className="icon-btn"
                onClick={() => onEdit(s.id)}
                aria-label={`Editar ${s.nome}`}
              >
                <img src={iconEdit} alt="" />
              </button>
              <button
                type="button"
                className="icon-btn danger"
                onClick={() => { if (window.confirm('Remover serviço?')) onDelete(s.id); }}
                aria-label={`Excluir ${s.nome}`}
              >
                <img src={iconTrash} alt="" />
              </button>
            </td>
          </tr>
        ))}
        {data.length < 6 &&
          Array.from({ length: 6 - data.length }).map((_, i) => (
            <tr key={`filler-${i}`} className="row-filler" aria-hidden="true">
              <td colSpan="6" />
            </tr>
          ))}
      </>
    );
  };
  // #endregion

  // #region Render
  return (
    <div className="servicos-module">
      <div className="servicos-head">
        <h2 className="servicos-title">Serviços</h2>
        <button type="button" onClick={onCreate} className="btn btn-primary">
          <span className="btn-icon">+</span> Novo Serviço
        </button>
      </div>
      <div className="table-wrapper" role="region" aria-label="Lista de serviços">
        <div className="table-filters" role="form" aria-label="Filtros">
          <input
            placeholder="Buscar por nome, categoria ou descrição..."
            value={local.q}
            onChange={e => update({ q: e.target.value })}
            aria-label="Buscar"
            disabled={loading}
          />
          <select
            value={local.categoria}
            onChange={e => update({ categoria: e.target.value })}
            aria-label="Categoria"
            disabled={loading}
          >
            <option value="TODAS">Todas as categorias</option>
            {categorias.map(c => (
              <option key={c} value={c}>{c}</option>
            ))}
          </select>
        </div>
        <div className="table-container">
          <table className="ct-table">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Categoria</th>
                <th>Descrição</th>
                <th>Preço Padrão</th>
                <th>Comissão</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>{renderBody()}</tbody>
          </table>
        </div>
        <div className="ct-footer" role="navigation" aria-label="Paginação">
          <div className="result-count">Total: {total}</div>
          <div className="pagination">
            <button onClick={() => jumpToPage(1)} disabled={page === 1 || loading} aria-label="Primeira página">&laquo;</button>
            <button onClick={() => jumpToPage(page - 1)} disabled={page === 1 || loading} aria-label="Página anterior">&lsaquo;</button>
            <label className="page-jump">
              <span className="sr-only">Página atual</span>
              <input
                value={String(page)}
                onChange={e => { const v = e.target.value.replace(/\D/g, ''); if (v) jumpToPage(Number(v)); }}
                aria-label="Ir para página"
                inputMode="numeric"
                disabled={loading}
              />
              <span className="total-pages">/ {totalPages}</span>
            </label>
            <button onClick={() => jumpToPage(page + 1)} disabled={page === totalPages || loading} aria-label="Próxima página">&rsaquo;</button>
            <button onClick={() => jumpToPage(totalPages)} disabled={page === totalPages || loading} aria-label="Última página">&raquo;</button>
          </div>
        </div>
      </div>
    </div>
  );
  // #endregion
}
